import colorRefinement from './color-refinement';
import sizeRefinement from './size-refinement';
import standardRefinement from './standard-refinement';
import widthRefinement from './width-refinement';

/**
 * @param {import('../../../../../type-definitions').Refinement} refinement - refinement
 * @param {import('../../../../../interface/refinement-url-builder').default} refinementURLBuilder - url builder
 * @param {Object} seoUrlConfig - SEO exclude configuration
 * @returns {string} HTML of the included refinement
 */
export default (refinement, refinementURLBuilder, seoUrlConfig) => {
    let refinementToBuild = standardRefinement;
    if (refinement.isSizeRefinement) {
        refinementToBuild = sizeRefinement;
    } else if (refinement.isWidthRefinement) {
        refinementToBuild = widthRefinement;
    } else if (refinement.isColorRefinement) {
        refinementToBuild = colorRefinement;
    } else if (refinement.isPriceRefinement) {
        /**
         * unsupported
         *
         * @returns {''} empty string
         */
        refinementToBuild = () => '';
    }

    return refinementToBuild(refinement, refinementURLBuilder, seoUrlConfig);
};
